import { keepPreviousData } from '@tanstack/react-query';

import { PackagesPolicy } from '@playq/octopus2-economy';
import { GenericFailure } from '@playq/services-shared';

import { IUseQueryOptionsExtended, useEitherQuery } from '/api/service-hooks';
import { services2 } from '/api/services2';

const policyPackagesQueryKeys: unknown[] = ['corp', 'policies', 'inventory', 'query'];

export const usePolicyPackagesQuery = (
  options?: IUseQueryOptionsExtended<PackagesPolicy | undefined, GenericFailure | Error>
) => {
  return useEitherQuery(policyPackagesQueryKeys, () => services2.packageAdminService.retrievePolicy(), {
    placeholderData: keepPreviousData,
    ...options,
  });
};
